export function requireOther(_, modifiers, context) {
  return {
    valid: modifiers && modifiers.length === 1 && modifiers[0] && !!context.formData[modifiers[0]],
    errorMessage: 'Bitte geben Sie einen Wert ein.',
  }
}
